// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { EscalatorFault } from './escalator-fault';


export class EscalatorFaultMessage implements flatbuffers.IUnpackableObject<EscalatorFaultMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):EscalatorFaultMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEscalatorFaultMessage(bb:flatbuffers.ByteBuffer, obj?:EscalatorFaultMessage):EscalatorFaultMessage {
  return (obj || new EscalatorFaultMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEscalatorFaultMessage(bb:flatbuffers.ByteBuffer, obj?:EscalatorFaultMessage):EscalatorFaultMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new EscalatorFaultMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

message():EscalatorFault {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : EscalatorFault.Underspeed;
}

static startEscalatorFaultMessage(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addMessage(builder:flatbuffers.Builder, message:EscalatorFault) {
  builder.addFieldInt16(0, message, EscalatorFault.Underspeed);
}

static endEscalatorFaultMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createEscalatorFaultMessage(builder:flatbuffers.Builder, message:EscalatorFault):flatbuffers.Offset {
  EscalatorFaultMessage.startEscalatorFaultMessage(builder);
  EscalatorFaultMessage.addMessage(builder, message);
  return EscalatorFaultMessage.endEscalatorFaultMessage(builder);
}

unpack(): EscalatorFaultMessageT {
  return new EscalatorFaultMessageT(
    this.message()
  );
}


unpackTo(_o: EscalatorFaultMessageT): void {
  _o.message = this.message();
}



unpackFields(...fields: string[]): EscalatorFaultMessageT {
  const t = new EscalatorFaultMessageT();
  const fieldSet = new Set(fields);
  if (fieldSet.has('message')) {
    t.message = this.message();
  }
  return t;
}
}

export class EscalatorFaultMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public message: EscalatorFault = EscalatorFault.Underspeed
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return EscalatorFaultMessage.createEscalatorFaultMessage(builder,
    this.message
  );
}

clone(): EscalatorFaultMessageT {
  const obj = new EscalatorFaultMessageT();
  obj.message = this.message;
  return obj;
}

equals(other: EscalatorFaultMessageT): boolean {
  if (this.message !== other.message) return false;
  return true;
}
}

export function verifyEscalatorFaultMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
  } finally {
    verifier.popDepth();
  }
}
